import React, {createRef} from "react"
import {findDOMNode} from "react-dom"
import DropdownPopoverSearch from "./popover-search"
import DropdownPopoverOptionsSelector from "./popover-options-selector"
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import Popover from "../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position"
import ModelEntity from "../../../../../model2/model-entity"
import MenuHelp from "../../../../../../layout/top/header/project/submenu/submenu-item/more-popover/menu-help"
import FieldDropdown from "../../dropdown"
import FieldProto from "../../../../proto/field-proto"

const SEARCH_SHOW_THRESHOLD = 6 // min options to show search input

// const debug = "FieldDropdown_PopoverMenu"
const debug = false

export type FieldPopoverMenuProps = {
    parent          : any,
    field           : FieldProto,
    model?          : ModelEntity

    currentOption?  : any // in case of stateless parent
}

export default class FieldDropdown_PopoverMenu extends React.Component<FieldPopoverMenuProps,any> {

    public optionsSelector  : any
    public scroll           : any

    public refHelp          : any = createRef()

    constructor(props:FieldPopoverMenuProps) {
        super(props)

        this.state = {
            searchString: null
        }
    }

    onPopoverKeyDown = (e:React.SyntheticEvent) => {if(this.optionsSelector) this.optionsSelector.onPopoverKeyDown(e)}

    onSearchChange = (newSearchString:string) => {
        this.setState({
            searchString: newSearchString
        })
    }

    onSetHelpMessage = (hint: string | null) => {
        this.refHelp.current?.setMessage(hint)
    }

    updateScroll = (node:any, isCentered = false) => {
        debug && console.log(debug, "updateScroll", node, isCentered, this.scroll)

        if (!node || !this.scroll) return

        const scrollNode:any = findDOMNode(this.scroll.childrenContainer)

        const nodeTop       = node.offsetTop
        const nodeBottom    = node.offsetTop + node.offsetHeight
        const scrollTop     = scrollNode.scrollTop
        const scrollBottom  = scrollNode.scrollTop + scrollNode.offsetHeight

        debug && console.log(debug, "updateScroll", scrollBottom < nodeBottom, scrollTop > nodeTop)

        // ensure node to be in visible area of scroll
        if (isCentered)                     this.scroll.setScrollTop((nodeTop + nodeBottom) / 2, true, 0)
        else if (scrollBottom < nodeBottom) this.scroll.setScrollTop(nodeBottom - scrollNode.offsetHeight, false, 100)
        else if (scrollTop > nodeTop)       this.scroll.setScrollTop(nodeTop, false, 100)
    }

    render() {
        const isManager = gd.ac.check.company.isManager()

        const PopoverMenuMore = _.get(this.props.field.components, 'PopoverMenuMore', false)
        const showHelp          = (this.props.field as FieldDropdown).showHelp

        let isSearchable : boolean
        if (this.props.model) { // this is added by vic (!)
            isSearchable      = this.props.field.isSearchable && this.props.field.getOptionsForEdit(this.props.model).length > SEARCH_SHOW_THRESHOLD
        } else {
            isSearchable      = this.props.field.isSearchable && this.props.field.getOptions()!.length > SEARCH_SHOW_THRESHOLD
        }


        const popoverPosition = new PopoverPosition({
            attachment      : "top center",
            targetAttachment: "bottom center",
        })

        return (
            <Popover popoverClass     = {this.props.field.fieldParams.popoverClassName}
                     position           = {popoverPosition}
                     getTargetFunc      = {()=>findDOMNode(this.props.parent)}
                     onKeyDown          = {this.onPopoverKeyDown}
                     onClickOutside     = {()=>{this.props.parent.hidePopover()}}>

                <DropdownPopoverSearch searchable       = {isSearchable}
                                       searchString     = {this.state.searchString}
                                       onHidePopover    = {this.props.parent.hidePopover}
                                       onSearchChange   = {this.onSearchChange}/>

                <div className={Classes("ui5-popover-menu", this.props.field.classes.PopoverMenu, {'with-help': (isManager && PopoverMenuMore) || showHelp})}>
                    <VScroll ref                = {(r:any)=>this.scroll = r}
                             minDragHeight      = {20}
                             containerClass     = {this.props.field.classes.PopoverMenuScrollContainer}
                             scrollVisibility   = "auto">

                        <DropdownPopoverOptionsSelector ref                 = {(r:any)=>this.optionsSelector = r}
                                                        {...this.props}
                                                        searchString        = {this.state.searchString}
                                                        onSetHelpMessage    = {this.onSetHelpMessage}
                                                        onUpdateScroll      = {this.updateScroll}/>
                    </VScroll>

                    {isManager && PopoverMenuMore &&
                        <PopoverMenuMore {...this.props}/>}

                    {showHelp &&
                        <MenuHelp ref               = {this.refHelp}
                                  defaultMessage    = "Mouse over menu item for help" />}
                </div>
            </Popover>
        )
    }
}
